/**
 * Phase 6 Part B: the one Telegram admin action that exists — `NotificationsEndpoints` has no
 * status/settings GET, so there is no query here to match it. See `types/notifications.ts`.
 */

import { api } from '../api.js';

export const notificationApi = api.injectEndpoints({
  endpoints: (build) => ({
    sendTestTelegramMessage: build.mutation<void, void>({
      query: () => ({ url: '/telegram/test-message', method: 'POST' }),
    }),
  }),
});

export const { useSendTestTelegramMessageMutation } = notificationApi;
